<template>
  <span class="quick-reserve-wrapper align-center" :style="inlineWrapperStyles" ref="quickReserve">
    <button
      :title="$t('grid.tooltips.createsReserveWithDurationMinutes', { minutes: intervalMinutes })"
      :data-testid="buttonTestId"
      @click.stop="handleCreateReserve">
      <i class="mdi mdi-lightning-bolt"></i>
    </button>
  </span>
</template>

<script>
import { DateTime } from 'luxon';

export default {
  props: {
    start: {
      type: String,
      required: true
    },
    dockId: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    intervalMinutes: {
      type: Number,
      required: true
    },
    inlineWrapperStyles: {
      type: Object,
      required: false,
      default: () => {}
    },
    accountForBusinessHours: {
      type: Boolean,
      required: false,
      default: true
    },
    dateObject: {
      type: Object,
      required: true
    },
    timezone: {
      type: String,
      required: true
    }
  },
  computed: {
    buttonTestId() {
      const formattedTimeInTimezone = DateTime.fromJSDate(this.dateObject)
        .setZone(this.timezone)
        .toFormat('HH:mm:ss');
      return `quick-reserve-${this.dockId}-${formattedTimeInTimezone}`;
    }
  },
  methods: {
    handleCreateReserve(event) {
      this.$emit('create-reserve', { start: this.start, dockId: this.dockId, e: event });
    },
    hideOutsideBusinessHours() {
      const coords = this.$refs.quickReserve.getBoundingClientRect();
      const resourceId = this.$refs.quickReserve.getAttribute('data-resource-id');

      const closedHours = document.querySelectorAll(
        `td.fc-resource[data-resource-id="${resourceId}"] .fc-non-business`
      );

      closedHours.forEach(closedHour => {
        const closedHourRect = closedHour.getBoundingClientRect();
        if (
          coords.left < closedHourRect.right &&
          coords.right > closedHourRect.left &&
          coords.top < closedHourRect.bottom &&
          coords.bottom > closedHourRect.top
        ) {
          this.$refs.quickReserve.style.setProperty('display', 'none', 'important');
        }
      });
    },
    hideIfEventExists() {
      const coords = this.$refs.quickReserve.getBoundingClientRect();

      const eventContainers = document.querySelectorAll('.event-container');
      eventContainers.forEach(eventContainer => {
        const eventContainerRect = eventContainer.getBoundingClientRect();
        if (
          coords.left < eventContainerRect.right &&
          coords.right > eventContainerRect.left &&
          coords.top < eventContainerRect.bottom &&
          coords.bottom > eventContainerRect.top
        ) {
          this.$refs.quickReserve.style.display = 'none';
        }
      });
    }
  },
  mounted() {
    if (this.accountForBusinessHours) {
      this.hideOutsideBusinessHours();
    }
    this.$nextTick(() => {
      this.hideIfEventExists();
    });
  }
};
</script>

<style scoped lang="scss">
button {
  border-radius: 50%;
  height: 20px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  &:hover {
    opacity: 0.5;
  }

  i {
    font-size: 13px;
    padding-top: 2px;
  }
}
</style>
